import { NavLink } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

export default function Navigation() {
  const { user, logout } = useAuthStore()
  const isClient = user?.role === 'client'

  // Навигация для тренера: Расписание | Главная | Клиенты | Выход
  const trainerNav = [
    { to: '/schedule', label: 'Расписание', icon: '📅' },
    { to: '/', label: 'Главная', icon: '🏠', exact: true },
    { to: '/clients', label: 'Клиенты', icon: '👥' },
  ]

  // Навигация для клиента: Тренировки | Главная | Ещё
  const clientNav = [
    { to: '/my-trainings', label: 'Тренировки', icon: '📅' },
    { to: '/', label: 'Главная', icon: '🏠', exact: true },
    { to: '/more', label: 'Ещё', icon: 'more' },
  ]

  const navItems = isClient ? clientNav : trainerNav

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-tg-secondary border-t border-tg-hint/20"
         style={{
           paddingBottom: 'env(safe-area-inset-bottom, 0px)',
           paddingLeft: 'env(safe-area-inset-left, 0px)',
           paddingRight: 'env(safe-area-inset-right, 0px)'
         }}>
      <div className="flex justify-around items-center h-14 max-w-lg mx-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
                isActive ? 'text-tg-button' : 'text-tg-hint'
              }`
            }
          >
            {item.icon === 'more' ? (
              <MoreIcon />
            ) : (
              <span className="text-xl mb-0.5">{item.icon}</span>
            )}
            <span className="text-[10px]">{item.label}</span>
          </NavLink>
        ))}

        {/* Кнопка выхода для тренера */}
        {!isClient && (
          <button
            onClick={logout}
            className="flex flex-col items-center justify-center flex-1 py-2 text-tg-hint active:text-red-500 transition-colors"
          >
            <span className="text-xl mb-0.5">🚪</span>
            <span className="text-[10px]">Выход</span>
          </button>
        )}
      </div>
    </nav>
  )
}

function MoreIcon() {
  return (
    <div className="w-5 h-5 mb-0.5 flex items-center justify-center">
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
        <circle cx="8" cy="12" r="1.5" fill="currentColor"/>
        <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
        <circle cx="16" cy="12" r="1.5" fill="currentColor"/>
      </svg>
    </div>
  )
}
